angular.module('unica_notification_template.notification_template_controllers')

.controller('NotificationTemplateListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm,
	NotificationTemplateListService, NotificationTemplateDeleteService, NotificationTemplateCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.notificationTemplateList = [];

	$scope.showLoader();

	loadNotificationTemplateList();
	
	function loadNotificationTemplateList() {
		NotificationTemplateListService
		.list($scope.event_id)
		.then(function(data) {
			$scope.hideLoader();

			if ( data ) {
				$scope.notificationTemplateList = data;
			}
		});
	}

	$scope.deleteNotificationTemplate = function(notificationTemplateId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il template?',
			text: 'Confermi la cancellazione del template?'
		}).then(function() {

			$scope.showLoader();

			NotificationTemplateDeleteService
				.delete( notificationTemplateId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.notificationTemplateList, function(notification, key) {
							if ( notification.id === notificationTemplateId ) {
								$scope.notificationTemplateList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Template Notifica eliminato con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.cloneNotificationTemplate = function(notificationTemplateId)
	{
		
			NotificationTemplateCreateService
				.clone( notificationTemplateId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$scope.showSuccessMsg('Template Notifica duplicato con successo!', '');
						loadNotificationTemplateList();

					}

				});

	};

})

;